module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-cascader', {
    attrs: {
      "options": _vm.provinceList,
      "props": _vm.addressProps
    },
    on: {
      "active-item-change": _vm.addressChange,
      "change": _vm.addressChangeData
    },
    model: {
      value: (_vm.address_data),
      callback: function($$v) {
        _vm.address_data = $$v
      },
      expression: "address_data"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8c4f72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/region.vue
// module id = 3506
// module chunks = 103